import { makeServerRequest, makeServerPost } from './util';

const apiPrefix = "/api/v1/invite";

export const inviteUserSuccess = (data) => {
    return {
        type: "RESET_PASSWORD_SUCCESS",
        payload: data
    };
};

export const inviteUserFailure = (error) => {
    return {
        type: "RESET_PASSWORD_FAILURE",
        payload: error
    };
};

export const inviteUser = (data) => {
    return (dispatch) => {
        dispatch({type: "INVITE_USER"});

        return makeServerPost(apiPrefix + "/update", data).then(
            response => dispatch(inviteUserSuccess(response.data))
        ).catch(
            error => dispatch(inviteUserFailure(error))
        );
    };
};

export const checkTokenSuccess = (data) => {
    return {
        type: "CHECK_TOKEN_SUCCESS",
        payload: data
    };
};

export const checkTokenFailure = (error) => {
    return {
        type: "CHECK_TOKEN_FAILURE",
        payload: error
    };
};

export const checkToken = (token) => {
    return (dispatch) => {
        dispatch({type: "CHECK_TOKEN"});

        return makeServerRequest(apiPrefix + "/token/" + token).then(
            response => dispatch(checkTokenSuccess(response.data))
        ).catch(
            error => dispatch(checkTokenFailure(error))
        );
    };
};




// WEBPACK FOOTER //
// ./src/store/actions/inviteUser.js